module.exports = __webpack_public_path__ + "img/losplatoslogo-dark.c38eab5a.png";